import { render } from "./AcessoRapido.vue?vue&type=template&id=28ebe6e8&scoped=true"
import script from "./AcessoRapido.vue?vue&type=script&lang=js"
export * from "./AcessoRapido.vue?vue&type=script&lang=js"

import "./AcessoRapido.vue?vue&type=style&index=0&id=28ebe6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ebe6e8"]])

export default __exports__